<template>
  <BaseDialog
    v-if="isOpen"
    :visible="isOpen"
    @close="emitCloseDialog"
    :config="actionConfig"
    @action="handleAction"
    :isValidForSubmit="isValidForSubmit"
  >
    <component
      :is="actionConfig.component"
      :actionData="actionData"
      :send="handleAction"
      ref="triggerAction"
      :visible="true"
      @close="emitCloseDialog"
      :config="actionConfig"
      @showNotification="showNotification"
      @isValidForSubmit="handleSubmitValidation"
      @followUpSent="onFollowUpSent"
    />
  </BaseDialog>
</template>

<script>
import BaseDialog from '../commons/BaseDialog.vue';
import config from './config.json'; // Import the JSON file
import { ref } from 'vue';
import SendQuoteDialog from './SendQuoteDialog.vue'; // No longer needed
import ChangeDueDate from './ChangeDueDate.vue'; // No longer needed
import UploadPOD from './UploadPOD.vue';
import SaveToBox from './SaveToBox.vue';
import WinOrLoss from './WinOrLoss.vue';
import ForwardToAppraiser from './ForwardToAppraiser.vue';
import SendAdminRequest from './SendAdminRequest.vue';
import ClientCommunication from './ClientCommunication.vue';
import ClientFollowUp from './ClientFollowUp.vue';
import ClientIntroduction from './ClientIntroduction.vue';
import PropertyFollowUp from './PropertyFollowUp.vue';

export default {
  name: 'QuickActionDialog',
  components: {
    BaseDialog,
    SendQuoteDialog, // No longer needed
    ChangeDueDate, // No longer needed
    UploadPOD,
    SaveToBox,
    WinOrLoss,
    SendAdminRequest,
    ForwardToAppraiser,
    ClientCommunication,
    ClientFollowUp,
    ClientIntroduction,
    PropertyFollowUp,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    actionType: {
      type: String,
      required: true,
    },
    actionData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      triggerAction: ref(null), 
      isValidForSubmit: false,
      config: config, // Store the imported config
    };
  },
  computed: {
    actionConfig() {
      return this.config[this.actionType] || {
        component: null ,
        title: 'Action',
        event: 'noaction-event',
        label: 'No Action',
      };
    }
  },
  methods: {
    emitCloseDialog() {
      this.$emit('close');
    },
    handleSubmitValidation(isValidForSubmit) {
      this.isValidForSubmit = isValidForSubmit;
    },
    handleAction(payload) {
      console.log('Action triggered:', this.$refs.triggerAction);
      console.log('Action config:', this.actionConfig);
      if (!this.$refs.triggerAction || !this.actionConfig.event) {
        console.error('Trigger action or event is not defined');
        return;
      }
      this.triggerAction = this.$refs.triggerAction;
      this.triggerAction[this.actionConfig.event]();
    },
    showNotification(message) {
      this.$emit('showNotification', message);
    },
    onFollowUpSent() {
      this.$emit('followUpSent');
    },
  }
};
</script>